import { render } from "./MaterialSwitch.vue?vue&type=template&id=21c15b1f&scoped=true"
import script from "./MaterialSwitch.vue?vue&type=script&lang=js"
export * from "./MaterialSwitch.vue?vue&type=script&lang=js"

import "./MaterialSwitch.vue?vue&type=style&index=0&id=21c15b1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c15b1f"]])

export default __exports__